import { useMutation } from '@apollo/client';
import { FormHandles, SubmitHandler } from '@unform/core';
import { format } from 'date-fns';
import { GRAPHQL_ATUALIZAR_STATUS_COLETA } from 'gql/coleta';
import { StatusName } from 'pages/coleta/listar/constants/status-name-2-id';
import { useCallback, useContext, useRef } from 'react';
import { useModalHistory } from 'routes/admin/hook/useModalHistory';
import { AuthContext } from 'routes/auth.context';

export const useSubmitEditarStatus = ({ firstDate, coletaId }) => {
    const history = useModalHistory();
    const formRef = useRef<FormHandles>(null);
    const { alertConfirm } = useContext(AuthContext);
    const [handleAtualizarStatusColeta, { loading: loadingButton }] =
        useMutation(GRAPHQL_ATUALIZAR_STATUS_COLETA);

    const toggleStatus = useCallback((e) => {
        const formData = formRef.current.getData();

        let maxCount = +e.target.value;
        if(maxCount === 8){
            maxCount = 0;
        } else {
            maxCount++;
        }

        const data = formData.data.map((itemMap, indice) => {
            const id = indice + 1;
            if (maxCount >= id) {
                return { ...itemMap, ativo: [`${indice}`] };
            }
            return { ...itemMap, ativo: [] };
        });
        const newData = { ...formData, data };
        formRef.current.setData(newData);
    }, []);

    const handleSubmit: SubmitHandler<any> = useCallback(
        async (data) => {
            try {
                const result = await handleAtualizarStatusColeta({
                    variables: { coletaStatus: [
                        {
                            statusId: Number(data.status),
                            dataAlteracao: new Date().toISOString(),
                            entregadorId: data.entregador,
                            coletaId,
                            codigoIfood: data.codigo_entrega,
                        }
                    ] },
                });
                if (!result?.data?.atualizarStatusColeta) {
                    throw new Error('Erro ao atualizar status da coleta, verifique se possui saldo pré pago suficiente.');
                }
                history.popTo();
            } catch ({ message }: any) {
                await alertConfirm({
                    tipo: 'erro',
                    titulo: 'Alerta',
                    conteudo: message as string,
                });
            }
        },
        [history, firstDate]
    );

    return {
        ref: formRef,
        toggleStatus,
        loadingButton,
        onSubmit: handleSubmit,
    };
};
